import { render, staticRenderFns } from "./OJFooter.vue?vue&type=template&id=56a8d65a&scoped=true"
import script from "./OJFooter.vue?vue&type=script&lang=js"
export * from "./OJFooter.vue?vue&type=script&lang=js"
import style0 from "./OJFooter.vue?vue&type=style&index=0&id=56a8d65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8d65a",
  null
  
)

export default component.exports